/* Optional, section-owned presentation only. No renderer, selection or commerce access.
 * Integration order and supported native markup: docs/case-selector/PRESENTATION.md. */
(function (root) {
  'use strict';
  if (root.ScCasePresentation) return;
  var cases = ['snap', 'tough', 'magsafe'];
  var instances = new WeakMap();
  function fail() { throw new Error('Case presentation unavailable'); }
  function all(node, selector) { return Array.from(node.querySelectorAll(selector)); }
  function owned(section, selector) {
    return all(section, selector).filter(function (node) { return node.closest('section[data-section]') === section; });
  }
  function one(node, selector) {
    var nodes = all(node, selector);
    if (nodes.length !== 1) fail();
    return nodes[0];
  }
  function attr(node, name, value) {
    if (value === null) node.removeAttribute(name);
    else node.setAttribute(name, value);
  }
  function visibility(node) {
    return { node: node, hidden: node.hidden, css: node.classList.contains('hidden'), aria: node.getAttribute('aria-hidden') };
  }
  function restore(row) {
    row.node.hidden = row.hidden;
    row.node.classList.toggle('hidden', row.css);
    attr(row.node, 'aria-hidden', row.aria);
  }
  function show(row, visible) {
    row.node.hidden = !visible;
    row.node.classList.toggle('hidden', !visible); // Native dot navigation counts this class.
    attr(row.node, 'aria-hidden', visible ? (row.aria === 'true' ? null : row.aria) : 'true');
  }
  function visible(node) { return !node.hidden && !node.classList.contains('hidden'); }
  function config(block) {
    var scripts = all(block, 'script[data-sc-case-media]');
    if (!scripts.length) return null;
    if (scripts.length !== 1) fail();
    var data;
    try { data = JSON.parse(scripts[0].textContent); } catch (_) { fail(); }
    if (!data || typeof data !== 'object' || Array.isArray(data)) fail();
    Object.keys(data).forEach(function (key) {
      if (['common'].concat(cases).indexOf(key) < 0 || !Array.isArray(data[key])) fail();
      var ids = new Set();
      data[key].forEach(function (id) {
        if (typeof id !== 'string' || !/^[1-9][0-9]*$/.test(id) || ids.has(id)) fail();
        ids.add(id);
      });
    });
    return data;
  }
  function prepare(args) {
    var section = args && args.section, block = args && args.block;
    if (!section || !block || !section.contains(block) || block.closest('section[data-section]') !== section) fail();
    if (instances.has(block)) return instances.get(block);
    var dead = false, initialized = false, groups, galleries = [], descriptions = [], modals = [], modalObserver;
    var preview = null, mount = null;
    // Remember real containment BEFORE the legacy host lifts the mount onto its viewer overlay.
    // Never guess that the first media item (or an arbitrary canvas/thumbnail) is the preview.
    function capturePreview() {
      var mounts = owned(section, '[data-pz-personalizer]');
      if (mounts.length !== 1) return;
      var slot = mounts[0].closest('.product__media-item');
      if (slot && section.contains(slot) && slot.closest('media-gallery')) {
        mount = mounts[0]; preview = slot;
      }
    }
    capturePreview();
    function init() {
      groups = config(block);
      var hasGroups = groups && cases.some(function (key) { return Object.prototype.hasOwnProperty.call(groups, key); });
      var templates = owned(section, 'template[data-sc-case-description-for]');
      var descs = owned(section, '[data-sc-case-description]');
      descriptions = descs.map(function (node) {
        var id = node.getAttribute('data-sc-case-description'), choices = Object.create(null);
        if (!id || descs.filter(function (n) { return n.getAttribute('data-sc-case-description') === id; }).length !== 1) fail();
        templates.filter(function (t) { return t.getAttribute('data-sc-case-description-for') === id; }).forEach(function (t) {
          var key = t.getAttribute('data-sc-case-description-template');
          if (cases.indexOf(key) < 0 || choices[key] || !t.content) fail();
          choices[key] = t;
        });
        return { node: node, choices: choices, original: Array.from(node.childNodes), hidden: node.hidden, current: null };
      }).filter(function (row) { return Object.keys(row.choices).length; });
      // A description block deliberately omitted from the template stays omitted.
      if (!hasGroups) { initialized = true; return; }
      capturePreview();
      var sectionId = section.getAttribute('data-section'), prefix = sectionId + '-';
      var nodes = owned(section, 'media-gallery').filter(function (g) { return g.getAttribute('data-section') === sectionId; });
      if (!nodes.length || !preview || !mount) fail();
      galleries = nodes.map(function (gallery) {
        var viewer = one(gallery, '[id^="GalleryViewer-"]');
        var thumbnails = all(gallery, '[id^="GalleryThumbnails-"]');
        if (thumbnails.length > 1) fail();
        var thumbSlider = thumbnails[0];
        var slides = all(viewer, '.product__media-item');
        var thumbs = thumbSlider ? all(thumbSlider, '[data-target]') : [];
        var dots = all(viewer, '.slider-counter__link');
        var ids = new Map();
        if (!slides.length || (dots.length && dots.length !== slides.length)) fail();
        slides.forEach(function (slide) {
          var id = slide.getAttribute('data-media-id');
          if (!id || id.indexOf(prefix) !== 0 || ids.has(id) || (!/^[1-9][0-9]*$/.test(id.slice(prefix.length)) && slide !== preview)) fail();
          ids.set(id, slide);
        });
        Object.keys(groups).forEach(function (key) {
          groups[key].forEach(function (id) { if (!ids.has(prefix + id)) fail(); });
        });
        thumbs.forEach(function (thumb) { if (!ids.has(thumb.getAttribute('data-target')) || !thumb.querySelector('button')) fail(); });
        if (thumbSlider && slides.some(function (slide) {
          return thumbs.filter(function (t) { return t.getAttribute('data-target') === slide.getAttribute('data-media-id'); }).length !== 1;
        })) fail();
        [viewer, thumbSlider].filter(Boolean).forEach(function (slider) {
          if (!slider.slider || typeof slider.resetPages !== 'function' || typeof slider.update !== 'function') fail();
        });
        if (thumbSlider && typeof gallery.setActiveThumbnail !== 'function') fail();
        return { node: gallery, viewer: viewer, thumbSlider: thumbSlider, slides: slides, thumbs: thumbs, dots: dots,
          rows: slides.concat(thumbs, dots).map(visibility), first: viewer.sliderFirstItemNode, touched: false };
      });
      if (!galleries.some(function (g) { return g.slides.indexOf(preview) >= 0 && g.viewer.contains(mount); })) fail();
      // Only the exact modal belonging to this section. No document-wide media queries.
      modals = owned(section, 'product-lightbox, product-modal').filter(function (m) {
        return m.id === 'ProductLightbox-' + sectionId || m.id === 'ProductModal-' + sectionId;
      }).map(function (node) {
        var lightbox = node.tagName.toLowerCase() === 'product-lightbox';
        var items = all(node, lightbox ? '.product-lightbox__slide' : '[data-media-id]');
        var list = lightbox ? one(node, '.splide__list') : null;
        var seen = new Set();
        var rows = items.map(function (item) {
          var id = item.getAttribute('data-media-id');
          if (!lightbox) id = prefix + id;
          if (seen.has(id) || !galleries.some(function (g) { return g.slides.some(function (s) { return s.getAttribute('data-media-id') === id; }); })
            || (lightbox && item.parentElement !== list)) fail();
          seen.add(id);
          return { item: item, id: id, visibility: visibility(item), active: item.classList.contains('active') };
        });
        if (lightbox && (typeof node.close !== 'function' || typeof node.buildDots !== 'function')) fail();
        return { node: node, lightbox: lightbox, list: list, rows: rows, parking: null, touched: false, changed: false };
      });
      var win = section.ownerDocument.defaultView;
      if (win && win.MutationObserver && modals.some(function (m) { return m.lightbox; })) {
        // A hidden Splide measures zero width. Refresh on native reopen, before its next-frame go().
        modalObserver = new win.MutationObserver(function () {
          if (dead) return;
          modals.forEach(function (m) { if (m.lightbox && !m.node.hidden && m.changed) refreshModal(m); });
        });
        modals.forEach(function (m) { if (m.lightbox) modalObserver.observe(m.node, { attributes: true, attributeFilter: ['hidden'] }); });
      }
      initialized = true;
    }
    function refresh(slider, items) {
      if (!slider) return;
      slider.resetPages();
      // Native initPages returns early for <2 measured slides, leaving stale offsets/counts.
      // Keep native methods/listeners; seed the degenerate page instead of overriding them.
      var measured = slider.sliderItemsToShow;
      if (slider.hasDots) slider.sliderFirstItemNode = items.filter(visible)[0];
      if (!measured || !measured.length) return; // e.g. CSS-hidden duplicate gallery at this breakpoint
      if (measured.length === 1) {
        slider.sliderItemOffset = (slider.vertical ? measured[0].clientHeight : measured[0].clientWidth) || 1;
        slider.slidesPerPage = 1; slider.totalPages = 1;
        slider.slider.scrollTo({ left: 0, top: 0, behavior: 'instant' });
      }
      slider.update();
    }
    function syncGallery(g, keep) {
      g.touched = true;
      var page = g.viewer.sliderItemsToShow && g.viewer.sliderItemsToShow[g.viewer.currentPage - 1];
      var active = page || g.slides.find(function (s) { return s.classList.contains('is-active'); });
      var slides = all(g.viewer, '.product__media-item');
      if (keep) {
        g.rows.forEach(function (row) {
          var node = row.node, index = g.dots.indexOf(node);
          var id = index >= 0 ? slides[index].getAttribute('data-media-id') : node.getAttribute('data-target') || node.getAttribute('data-media-id');
          show(row, keep.has(id));
        });
      } else g.rows.forEach(restore);
      var shown = slides.filter(visible);
      active = shown.indexOf(active) >= 0 ? active : shown.indexOf(preview) >= 0 ? preview : shown[0];
      if (!active && keep) fail();
      slides.forEach(function (s) { s.classList.toggle('is-active', s === active); });
      // Rebase the existing track, not the page/URL, before native pagination measures it.
      if (active) g.viewer.slider.scrollTo({ left: active.offsetLeft, behavior: 'instant' });
      refresh(g.viewer, slides);
      refresh(g.thumbSlider, g.thumbs);
      if (g.thumbSlider && active) {
        var thumb = g.thumbs.find(function (t) { return t.getAttribute('data-target') === active.getAttribute('data-media-id'); });
        g.node.setActiveThumbnail(thumb);
        if (g.thumbSlider.sliderItemsToShow.length) g.thumbSlider.update();
      }
      // Replace any debounced pre-filter slideChanged intent, even if its page NUMBER stayed
      // the same. Otherwise native onSlideChanged can later select a now-excluded thumbnail.
      var win = section.ownerDocument.defaultView;
      if (active) g.viewer.dispatchEvent(new win.CustomEvent('slideChanged', { detail: { currentPage: g.viewer.currentPage, currentElement: active } }));
      g.touched = !!keep;
    }
    function refreshModal(m) {
      if (!m.node.splide) return;
      m.node.splide.refresh();
      m.node.buildDots(m.node.querySelector('.product-lightbox__dots'));
    }
    function syncModal(m, keep) {
      m.touched = true; m.changed = true;
      if (m.lightbox) {
        if (m.node.isOpen) m.node.close();
        if (!m.parking && keep) {
          m.parking = section.ownerDocument.createElement('div');
          m.parking.hidden = true;
          m.parking.style.setProperty('display', 'none', 'important');
          m.node.appendChild(m.parking);
        }
        // Splide counts hidden slides. Park excluded ORIGINAL modal nodes outside its list,
        // without the slide query marker. Keep zoom wrappers inside the lightbox so its lazy
        // initializer still creates native zoom handlers for every original image, just once.
        var next = null;
        m.rows.slice().reverse().forEach(function (row) {
          var include = !keep || keep.has(row.id);
          row.item.classList.toggle('product-lightbox__slide', include);
          if (include) {
            if (row.item.parentElement !== m.list || row.item.nextElementSibling !== next) m.list.insertBefore(row.item, next);
            next = row.item;
          } else if (row.item.parentElement !== m.parking) m.parking.appendChild(row.item);
        });
        if (m.node.zoomStates && m.node.zoomStates.length) {
          var wraps = all(m.node, '[data-zoomable]');
          m.node.zoomStates.sort(function (a, b) { return wraps.indexOf(a.wrap) - wraps.indexOf(b.wrap); });
        }
        if (!keep && m.parking) { m.parking.remove(); m.parking = null; }
        refreshModal(m);
        if (m.node.splide && m.list.children.length) m.node.splide.go(0);
      } else {
        m.rows.forEach(function (row) {
          if (keep) show(row.visibility, keep.has(row.id));
          else restore(row.visibility);
          if (!keep) row.item.classList.toggle('active', row.active);
          else if (!visible(row.item)) row.item.classList.remove('active');
        });
        var shown = m.rows.filter(function (row) { return visible(row.item); });
        if (keep && shown.length && !shown.some(function (row) { return row.item.classList.contains('active'); })) shown[0].item.classList.add('active');
      }
      m.touched = !!keep;
    }
    var api = {
      apply: function (caseKey) {
        if (dead) return;
        if (!initialized) init(); // Validate everything before the first presentation write.
        var hasGroups = galleries.length > 0;
        if (!hasGroups && !descriptions.length) return;
        if (cases.indexOf(caseKey) < 0) fail();
        var keep = null;
        if (hasGroups && Object.prototype.hasOwnProperty.call(groups, caseKey)) {
          capturePreview();
          var previewGallery = galleries.find(function (g) { return g.slides.indexOf(preview) >= 0 && g.viewer.contains(mount); });
          if (!previewGallery || owned(section, '[data-pz-personalizer]').length !== 1) fail();
          keep = new Set((groups.common || []).concat(groups[caseKey]).map(function (id) { return section.getAttribute('data-section') + '-' + id; }));
          keep.add(preview.getAttribute('data-media-id'));
          // An empty duplicate gallery has no preview to paginate. Refuse before any writes.
          if (galleries.some(function (g) { return !g.slides.some(function (s) { return keep.has(s.getAttribute('data-media-id')); }); })) fail();
        }
        galleries.forEach(function (g) { if (keep || g.touched) syncGallery(g, keep); });
        modals.forEach(function (m) { if (keep || m.touched) syncModal(m, keep); });
        descriptions.forEach(function (row) {
          var choice = row.choices[caseKey] || null;
          if (choice === row.current) return;
          if (choice) row.node.replaceChildren(choice.content.cloneNode(true));
          else row.node.replaceChildren.apply(row.node, row.original);
          row.node.hidden = choice ? false : row.hidden;
          row.current = choice;
        });
      },
      destroy: function () {
        if (dead) return;
        dead = true;
        if (modalObserver) modalObserver.disconnect();
        // Restore only owned presentation, never the host's renderer/controller state.
        galleries.forEach(function (g) {
          if (g.touched) { syncGallery(g, null); g.viewer.sliderFirstItemNode = g.first; }
        });
        modals.forEach(function (m) { if (m.touched) syncModal(m, null); });
        descriptions.forEach(function (row) {
          if (row.current) { row.node.replaceChildren.apply(row.node, row.original); row.node.hidden = row.hidden; }
        });
        instances.delete(block);
      }
    };
    instances.set(block, api);
    return api;
  }
  root.ScCasePresentation = { prepare: prepare };
}(typeof self !== 'undefined' ? self : this));
